import React from 'react';
import { toast } from 'react-toastify';
import { Col, Row } from 'reactstrap';
import PageTitle from '../common/PageTitle';
import ChangePassword from './changePassword';
import ChangeEmail from './changeEmail';
import profileService from '../../services/profileService';
import QrCode from '../common/modals/qrcode';
import { confirm } from './../common/modals/confirmService'

export default class Profile extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      username: '',
      email: '',
      accountId: '',
      accountNumber: '',
      showModalQrCode: false
    }
    this.handleShowQrCodeModal = this.handleShowQrCodeModal.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleUnbind = this.handleUnbind.bind(this);
  }

  componentDidMount() {
    this.getUser()
  }

  getUser() {
    profileService.refreshProfile().then(response => {
      this.setState({
        username: response.username,
        email: response.email,
        accountId: response.accountId ? response.accountId : null,
        accountNumber: response.accountNumber ? response.accountNumber : null,
      })
    }).catch(error => {
      toast.error(error.response, this.options)
    })
  }

  handleClose() {
    this.setState({ showModalQrCode: false });
    this.getUser()
  }
  handleShowQrCodeModal() {
    this.setState({ showModalQrCode: true });
  }

  handleUnbind() {
    confirm('Are you sure you want to unbind the account from the profile?').then(() => {
      profileService.disconnectAccount().then(response => {
        toast.success("Account unbinded successuffuly!", this.options);
        this.getUser()
      }).catch(error => {
        toast.error(error.response, this.options)
      })
    }, () => { });
  }

  render() {
    const { showModalQrCode, accountId, accountNumber } = this.state;

    return (
      <div className="wrapper profile-page-container">
        {showModalQrCode ? <QrCode show={showModalQrCode} handleClose={this.handleClose} /> : null}
        <div className="profile">
          <Row noGutters className="page-header py-4 justify-content-center">
            <PageTitle sm="4" title="My account" className="text-md-center" />
          </Row>
          <div className="border-bottom"></div>
          <Row noGutters className="py-4 justify-content-center">
            <Col sm="12" md="10" xl="10" >
              <ChangeEmail />
              <ChangePassword />
              <div>
                <ul>
                  {accountId ?
                    <li>
                      <p>Application number: </p>
                      <span>{accountNumber} </span>
                      <span className="clearfix">
                        <button className="btn btn-lightblue pull-right mb-3" onClick={this.handleUnbind}>Unbind</button>
                      </span>
                    </li> :
                    <li>
                      <h6 className="mt-3 mb-3 grey clearfix"> Application number  <span className="pull-right"><button className="btn btn-lightblue " onClick={this.handleShowQrCodeModal}>Unbind</button></span></h6>
                    </li>
                  }
                </ul>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    )
  }
};


// WEBPACK FOOTER //
// ./src/components/profile/profile.js